import { useState } from "react";
import styles from "../../../styles/Offerings/MobileOfferingPlan.module.css";
import MobileStageOffering from "./MobileStageOffering";

const MobileOfferringPlan = () => {
  const [selectedStage, setSelectedStage] = useState("Idea Stage");

  const changeStage = (stage) => {
    setSelectedStage(stage);
  };
  const stageData = {
    ideaStage: [
      { label: "Price", value: "₹50/K Month" },
      {
        label: "Startup Evaluation (₹10K Value)",
        value: "Free",
        highlight: true,
      },
      { label: "Ready-to-Launch Templates", value: "Included" },
      { label: "1:1 Consulting Support (Up to 10 Hrs/Month)", value: "Check" },
      { label: "Mentoring Support", value: "Wrong" },
      { label: "Scaling & Growth Hacking Support", value: "Wrong" },
      { label: "Ideal For", value: "Idea Validation & MVP Planning" },
      { label: "Know More", value: "Idea Stage", link: "/idea-stage" },
    ],
    valleyStage: [
      { label: "Price", value: "₹1/L Month" },
      {
        label: "Startup Evaluation (₹10K Value)",
        value: "Free",
        highlight: true,
      },
      { label: "Ready-to-Launch Templates", value: "Included" },
      { label: "1:1 Consulting Support (Up to 10 Hrs/Month)", value: "Check" },
      { label: "Mentoring Support", value: "Included" },
      { label: "Scaling & Growth Hacking Support", value: "Wrong" },
      { label: "Ideal For", value: "Overcoming Early Challenges" },
      { label: "Know More", value: "Valley Stage", link: "/valley-stage" },
    ],
    growthStage: [
      { label: "Price", value: "₹1.5/L Month" },
      {
        label: "Startup Evaluation (₹10K Value)",
        value: "Free",
        highlight: true,
      },
      { label: "Ready-to-Launch Templates", value: "Included" },
      { label: "1:1 Consulting Support (Up to 10 Hrs/Month)", value: "Check" },
      { label: "Mentoring Support", value: "Included" },
      { label: "Scaling & Growth Hacking Support", value: "Check" },
      { label: "Ideal For", value: "Scaling & Growth" },
      { label: "Know More", value: "Growth Stage", link: "/growth-stage" },
    ],
  };

  return (
    <div className={styles.mobileOfferingPlanContainer}>
      <div className={styles.mobileOfferingPlanInnerContainer}>
        <div>
          <div className={styles.mobileOfferingPlanTitle}>Choose Your Plan</div>
          <div className={styles.mobileOfferingPlanDesc}>
            Compare Our Offerings & Select What Works Best for You
          </div>
        </div>
        <div>
          <div className={styles.mobileOfferingPlanStageContainer}>
            <div>Idea Stage</div>
            <img
              src="/up.svg"
              alt="up_arrow"
              className={`${
                selectedStage === "Idea Stage" ? styles.upArrow : ""
              }`}
              onClick={() => changeStage("Idea Stage")}
            />
          </div>
          <hr style={{ margin: " 2rem 0" }} />
          {selectedStage === "Idea Stage" && (
            <MobileStageOffering data={stageData.ideaStage} />
          )}
          <div className={styles.mobileOfferingPlanStageContainer}>
            <div>Valley Stage</div>
            <img
              src="/up.svg"
              alt="up_arrow"
              className={`${
                selectedStage === "Valley Stage" ? styles.upArrow : ""
              }`}
              onClick={() => changeStage("Valley Stage")}
            />
          </div>
          <hr style={{ margin: "2rem 0" }} />
          {selectedStage === "Valley Stage" && (
            <MobileStageOffering data={stageData.valleyStage} />
          )}
          <div className={styles.mobileOfferingPlanStageContainer}>
            <div>Growth Stage</div>
            <img
              src="/up.svg"
              alt="up_arrow"
              className={`${
                selectedStage === "Growth Stage" ? styles.upArrow : ""
              }`}
              onClick={() => changeStage("Growth Stage")}
            />
          </div>
          <hr style={{ margin: "1rem 0", opacity: "0" }} />
          {selectedStage === "Growth Stage" && (
            <MobileStageOffering data={stageData.growthStage} />
          )}
        </div>
      </div>
    </div>
  );
};

export default MobileOfferringPlan;
